import { EmployeeIdentificationType } from '@fora-monorepo/employer-my-pages-common/types';
import { Container, RadioButton, Text, useRadioButton, VerticalSpacer } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../i18n/i18n';

export const PersonalIdentityRadioButtons = ({
  radioButtonProps,
  name,
}: {
  radioButtonProps: ReturnType<typeof useRadioButton>;
  name: string;
}) => {
  const { t } = useTypedTranslation();
  return (
    <Container marginBottom={40}>
      <Text marginTop={-10} marginBottom={20}>
        {t('form.editEmployee.personalInformationText', {
          firstName: name,
        })}
      </Text>
      <RadioButton
        id="radio-button-noChange"
        value={''}
        name="Nej"
        onChange={radioButtonProps.onChange}
        checked={radioButtonProps.value === ''}
        label={t('form.editEmployee.radioButtonNoChange')}
        error={false}
        disabled={false}
      />
      <VerticalSpacer marginBottom={20} />
      <RadioButton
        id="radio-button-coOrdinationNumber"
        value={EmployeeIdentificationType.CoOrdinationNumber}
        name="radio-button-group-1"
        onChange={radioButtonProps.onChange}
        checked={radioButtonProps.value === EmployeeIdentificationType.CoOrdinationNumber}
        label={t('form.editEmployee.radioButtonNewCoOrdinationNumber')}
        error={false}
        disabled={false}
      />
      <VerticalSpacer marginBottom={20} />
      <RadioButton
        id="radio-button-personalIdentityNumber"
        value={EmployeeIdentificationType.PersonalIdentityNumber}
        name="radio-button-group-1"
        onChange={radioButtonProps.onChange}
        checked={radioButtonProps.value === EmployeeIdentificationType.PersonalIdentityNumber}
        label={t('form.addEmployee.swedishPersonalIdentityNumberLabel')}
        error={false}
        disabled={false}
      />
    </Container>
  );
};
